/**
 * Backend API origin (no trailing slash).
 * Change `apiUrl` here only — axios (`http_common.js`), uploads, proxy-image URLs,
 * and Node SSR servers read this value.
 */
// const apiUrl = "https://api.brokeragentbase.com";
const apiUrl = "https://staging-api.brokeragentbase.com";
// const apiUrl = "http://localhost:4000";

const environment = {
  apiUrl,
  /** Full URL for multipart upload endpoint */
  uploadUrl: `${apiUrl}/upload`,
  /** Full URL for asset upload (e.g. logos) */
  uploadAssetUrl: `${apiUrl}/uploadasset`,
};

export default environment;
